<template>
  <div id="tournament-hero-box" class="to-center-abs">
    <info-badge
      id="info-tournament"
      placement="left"
      :info-text="$t('info_badge.tournament')"
      size="lg"
      class="mt-3"
    />
  </div>
</template>
<script>
import InfoBadge from "@/components/base/info-badge.vue";

export default {
  name: "TournamentHeroBox",
  components: { InfoBadge },
};
</script>
<style lang="scss">
#tournament-hero-box {
  bottom: 0;
  width: 700px;
  height: 100%;
}
</style>
